export default "__VITE_ASSET__DtVH9FP7__"